import useModalStore from '@/stores/modal.store';

export const useModal = () => useModalStore((state) => state);
